import React from 'react';
import PropTypes from 'prop-types';

function ClockIcon({ color = 'black', width = 14, height = 14 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.00065 0.333008C10.6807 0.333008 13.6673 3.31967 13.6673 6.99967C13.6673 10.6797 10.6807 13.6663 7.00065 13.6663C3.32065 13.6663 0.333984 10.6797 0.333984 6.99967C0.333984 3.31967 3.32065 0.333008 7.00065 0.333008ZM7.00065 12.333C9.94732 12.333 12.334 9.94634 12.334 6.99967C12.334 4.05301 9.94732 1.66634 7.00065 1.66634C4.05398 1.66634 1.66732 4.05301 1.66732 6.99967C1.66732 9.94634 4.05398 12.333 7.00065 12.333ZM9.35798 3.69967L10.3007 4.64234L7.00065 7.94234L6.05798 6.99967L9.35798 3.69967V3.69967Z"
        fill={color}
      />
    </svg>
  );
}

ClockIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default ClockIcon;
